var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "15px",
    viewBox: "0 0 16 17.14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "audio") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "7---new-icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-585.000000, -454.000000)",
    fillRule: "nonzero",
    stroke: "#0BD6A7",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(586.000000, 455.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-8",
    cx: 2.11764706,
    cy: 11.2736842,
    rx: 2.11764706,
    ry: 1.98947368
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-8-Copy",
    cx: 9.17647059,
    cy: 7.95789474,
    rx: 2.11764706,
    ry: 1.98947368
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "4.23529412 11.2736842 4.23529412 2.65263158 11.2941176 6.03138592e-13"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.2941176,
    y1: 8.02288115,
    x2: 11.2941176,
    y2: 2.59251752e-7,
    id: "Path-6-Copy",
    strokeLinejoin: "round",
    transform: "translate(11.294118, 4.011441) scale(-1, 1) translate(-11.294118, -4.011441) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudio);
export default __webpack_public_path__ + "static/media/icon-audio.7ea9143d.svg";
export { ForwardRef as ReactComponent };